import Navbar from "../Layout/Navbar";
import Hero from "../components/Homepage/Hero";
import Intro from "../components/Homepage/Intro";
import Services from "../components/Homepage/Services";
import About from "../components/Homepage/About";
import Testimonials from "../components/Homepage/Testimonials";
import ContactCTA from "../components/Homepage/ContactCTA";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Cate from "../components/Homepage/Cate";

const HomePage = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 150);
      }
    }
  }, [hash]);

  return (
    <div className="bg-darkbg text-white">
      <section id="hero">
        <Hero />
      </section>

      <section id="intro">
        <Intro />
      </section>

      <section id="category">
        <Cate />
      </section>

      {/* <section id="services">
        <Services />
      </section>

      <section id="testimonials">
        <Testimonials />
      </section> */}

      <section id="contact">
        <ContactCTA />
      </section>
    </div>
  );
};

export default HomePage;
